function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUhub(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M17.681 11.31l3.841 2.3c.345.23.368.253.368.552v4.554a.714.714 0 01-.368.644l-3.91 2.3c-.253.138-.322.138-.621 0l-3.91-2.3c-.253-.138-.368-.23-.368-.644v-4.462c0-.368.069-.46.368-.644l3.91-2.3c.299-.138.437-.138.69 0zm-.445 1.909l-.017.016-2.132 1.165a.128.128 0 00-.066.066c-.033.082-.016.164.05.213l.016.016 2.132 1.083c.033.017.082.017.131 0l.017-.016 2.083-1.083a.128.128 0 00.066-.066c.04-.052.026-.126-.014-.178l-.052-.051-2.083-1.165c-.033-.016-.082-.033-.131 0zM7.078 11.31l3.841 2.3c.345.23.368.253.368.552v4.554a.714.714 0 01-.368.644l-3.91 2.3c-.253.138-.322.138-.621 0l-3.91-2.3c-.253-.138-.368-.23-.368-.644v-4.462c0-.368.069-.46.368-.644l3.91-2.3c.299-.138.437-.138.69 0zm-.445 1.909l-.017.016L4.484 14.4a.128.128 0 00-.066.066c-.033.082-.016.164.05.213l.016.016 2.132 1.083c.033.017.082.017.131 0l.017-.016 2.083-1.083a.128.128 0 00.066-.066c.04-.052.026-.126-.014-.178l-.052-.051-2.083-1.165c-.033-.016-.082-.033-.131 0zM12.39 2.104l3.841 2.3c.345.23.368.253.368.552V9.51a.714.714 0 01-.368.644l-3.91 2.3c-.253.138-.322.138-.621 0l-3.91-2.3c-.253-.138-.368-.23-.368-.644V5.048c0-.368.069-.46.368-.644l3.91-2.3c.299-.138.437-.138.69 0zm-.445 1.91l-.017.016-2.132 1.164a.128.128 0 00-.066.066c-.033.082-.016.164.05.213l.016.017 2.132 1.082c.033.017.082.017.131 0l.017-.016 2.083-1.083a.128.128 0 00.066-.065c.04-.053.026-.126-.014-.179l-.052-.051-2.083-1.165c-.033-.016-.082-.033-.131 0z"
  }));
}

SvgUhub.clsName = 'icon-www__uhub';
SvgUhub.remarkName = 'unknown';
export default SvgUhub;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uhub.js
// module id = 2485
// module chunks = 17 18